import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { Roles } from '../model/Roles';
import { UserManagementViewService } from '../services/user-management-view.service';
import { UserManagementService } from '../services/user-management.service';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    standalone: false
})
export class RolesComponent implements OnInit{
    public isLoading: boolean = true
    public displayedColumns: string[] = [
        'rol',
        'abreviacion',
        'tipo',
        'action',
    ];
    public rolesForm: UntypedFormGroup;
    public dataSource: Roles[];
    public tipoList: any[];
    public toggleAddBtn: boolean = false;
    public toggleUpdateBtn: boolean = false;

    constructor(
        private _dialog: MatDialog,
        private _dialogRef: MatDialogRef<RolesComponent>,
        private _userManagementService: UserManagementService,
        public _viewService: UserManagementViewService,
        private _sharedService: SharedService,
        private _fb: UntypedFormBuilder
    ) {
        this._viewService.getTipoList();
        this.initRolesForm();
        this.getAllRoles();
    }
    ngOnInit(): void {       
      
    }

    initRolesForm() {
        this.rolesForm = this._fb.group({
            rolId: [0],
            rol: [''],
            abreviacion: [''],
            tipo: ['P'],
        });
    }

    getAllRoles() {
        this._userManagementService.getRoles().subscribe((response) => {
            this.dataSource = response.result;
            this.dataSource.forEach((role) => {
                role['isEdit'] = false;
            });
            this.isLoading = false
        });
    }

    addNewRole() {
        this._userManagementService.addRole(this.rolesForm.value).subscribe(
            (res) => {
                if (res.result !== 0) {
                    this.toggleAddForm();
                    this.getAllRoles();
                    this.onReset();
                    this._sharedService.ShowSnackBar('Guardado con éxito');
                } else {
                    this._sharedService.ShowSnackBar(
                        'La empresa ya está introducida'
                    );
                }
            },
            (err) => {
                this._sharedService.ShowSnackBar('Se produjo un error');
                console.error(err);
            }
        );
    }

    updateRole(role: any) {
        //remove is edit field before submiting
        delete role['isEdit'];

        this._userManagementService.updateRole(role).subscribe(
            (res) => {
                if (res.code === 0 && res.result === 1) {
                    this.toggleUpdate();
                    this.getAllRoles();
                    this._sharedService.ShowSnackBar(
                        'Actualizado con éxito',
                        'Okay',
                        2000
                    );
                } else {
                    this._sharedService.ShowSnackBar(
                        'Error al guardar',
                        'Okay',
                        2000
                    );
                }
            },
            (err) => {
                this._sharedService.ShowSnackBar(
                    'Se produjo un error',
                    'Okay',
                    2000
                );
            }
        );
    }

    deleteRole(role: any) {
        const dialogData = new ConfirmDialogModel('¿Eliminar el rol? ', '');
        const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
            data: dialogData,
        });
        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                this._userManagementService.deleteRole(role.rolId).subscribe(
                    (result) => {
                        if (result) {
                            this.getAllRoles();
                            this._sharedService.ShowSnackBar(
                                'Borrado exitosamente',
                                'Okay',
                                2000
                            );
                        } else {
                            this._sharedService.ShowSnackBar(
                                'Se produjo un error',
                                'Okay',
                                2000
                            );
                        }
                    },
                    (err) => {
                        console.error(err);
                        this._sharedService.ShowSnackBar(
                            'Se produjo un error',
                            'Okay',
                            2000
                        );
                    }
                );
            }
        });
    }

    onReset() {
        //reset form except for RolId and Tipo
        this.rolesForm.reset({
            rolId: this.rolesForm.get('rolId').value,
            tipo: this.rolesForm.get('tipo').value,
        });
    }

    cancelUpdate() {
        this.toggleUpdate();
        this.getAllRoles();
    }

    cancel() {
        this._dialogRef.close();
    }

    toggleAddForm() {
        this.toggleAddBtn = !this.toggleAddBtn;
    }

    toggleUpdate(role?) {
        this.toggleUpdateBtn = !this.toggleUpdateBtn;
        if (role) role.isEdit = !role.isEdit;
    }
}
